import {ActionsTransform} from "./ActionsTransform";
import {assistantsTransform} from "../assistants/AssistantsTransform";

import {
  SendSmsRecordModel,
  SendSmsListModel,
  SendSmsCreateModel,
  SendSmsUpdateModel,
} from "@/api/models";
import {SmsAction, PaginatedResponse} from "@/api/services";
import {BaseAction} from "@/types/api";

export class ActionSmsTransform extends ActionsTransform<
  SendSmsRecordModel,
  SendSmsCreateModel,
  SendSmsUpdateModel
> {
  public makeRecordModel(dto: SmsAction & BaseAction): SendSmsRecordModel {
    const model: SendSmsRecordModel = {
      ...dto,
      title: dto.name,
      description: "",
      condition: dto.condition,
      smsContent: dto.content,
      assistants: dto.assistants.map(assistant =>
        assistantsTransform.makeEvenCompactModel(assistant),
      ),
    };

    return model;
  }

  public makeListModel(dto: PaginatedResponse): SendSmsListModel {
    const model: SendSmsListModel = {
      records: dto.items.map(item =>
        this.makeRecordModel(item as SmsAction & BaseAction),
      ),
      pagination: this.makePaginationModel(dto),
    };

    return model;
  }

  public makeCreateDto(model: SendSmsCreateModel): SmsAction {
    const dto: SmsAction = {
      type: "sms",
      workspace_id: model.workspaceId,
      name: model.name,
      condition: model.condition,
      content: model.content,
    };

    return dto;
  }

  public makeUpdateDto(model: SendSmsUpdateModel): SmsAction {
    const dto: SmsAction = {...this.makeCreateDto(model)};

    return dto;
  }
}

export const actionSmsTransform = new ActionSmsTransform();
